import { Member } from '@nextforce/api'

export function filterMembers(
  recipients: Member[] | readonly Member[] | null | undefined,
  searchText: string
): Member[] {
  return (
    recipients?.filter((recipient, index, self) => {
      const name = (
        recipient.firstName +
        ' ' +
        recipient.lastName
      ).toLowerCase()
      return (
        name.includes(searchText.toLowerCase()) &&
        index === self.findIndex(r => r.id === recipient.id)
      )
    }) ?? []
  )
}
